<template>
    <van-row gutter="10">
        <van-col span="9" class="ta-right">
            <span class="sseTimeTitle fts-32">上证综合指数</span>
        </van-col>
        <van-col span="15" v-if="data">
            <div class="sseNumPart left">
                <div>
                    <span class="sseNumOne"><k-num :value="data.currentPrice" :skin="data.diffMoney"/></span>
                    <span class="sseNumTwo"><k-num :value="data.diffMoney" :sign="true" /></span>
                    <span class="sseNumTwo" :class="className(data.diffRate)">(<k-updown :value="data.diffRate" :mark="true" />)</span>
                </div>
                <p class="sseNumThr">
                    <span class="">今开</span>
                    <span class=""><k-num :value="data.openPrice"/></span>
                    &nbsp;
                    <span class="">昨收</span>
                    <span class=""><k-num :value="data.yestodayClosePrice"/></span></p>
                </div>
        </van-col>
    </van-row>
</template>
<script>

    export default {
        props : {
            data : {
                type : Object,
                default : null
            }
        },
        data() {
            return {
                
            }
        },
        computed: {
            
        },
        methods: {
            className (value){
                return value < 0 ? 'down' : value > 0 ? 'up' : 'flat'
            }
        },
    }
</script>